
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.247 4.335a1.018 1.018 0 011.51 0l5.33 5.713a1.203 1.203 0 010 1.617 1.018 1.018 0 01-1.509 0L8 6.76l-4.578 4.903a1.018 1.018 0 01-1.51 0 1.203 1.203 0 010-1.618l5.332-5.713.003.004z","fill":"#fff"}})])
          )
        }
      }
    